'use client';

import { getFirebaseAuthClient } from '@/lib/firebase/client';

export async function getClientAuthHeaders(init?: HeadersInit) {
  const headers = new Headers(init);
  const auth = getFirebaseAuthClient();
  const currentUser = auth?.currentUser;
  if (currentUser) {
    const token = await currentUser.getIdToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
  }
  return headers;
}

export async function fetchWithAppAuth(input: RequestInfo | URL, init?: RequestInit) {
  const headers = await getClientAuthHeaders(init?.headers);
  return fetch(input, {
    ...init,
    headers,
    credentials: init?.credentials ?? 'include',
  });
}
